import React, { useCallback } from 'react'

export default function PaypalMessage(props) {
  const {
    amount, styleCSS, conditionToDisplay = true, textSize = '12',
  } = props

  const initPaypalMessage = useCallback(() => {
    const hasPaypalMessages = __BROWSER__ && window.paypal && window.paypal.Messages
    if (hasPaypalMessages && conditionToDisplay) {
      try {
        window.paypal.Messages.render()
      } catch (e) {
        console.error(e)
      }
    }
  },
  [conditionToDisplay])

  return conditionToDisplay && (
    <div
      ref={initPaypalMessage}
      data-pp-message
      data-pp-placement="product"
      data-pp-amount={amount}
      data-pp-style-layout="text"
      data-pp-style-logo-type="none"
      style={styleCSS}
      data-pp-style-text-size={textSize}
    />
  )
}
